<p-table [value]="subscriptionService$ | async" [loading]="showSkeleton" styleClass="my-3" responsiveLayout="scroll" [lazy]="true">
    <ng-template pTemplate="header">
      <tr>
        <th class="surface-100 border-0 py-2"><span class="text-xs text-600 white-space-nowrap">{{'SUBSCRIPTIONS.SERVICES.PRODUCT'| translate }}</span></th>
        <th class="surface-100 border-0 py-2"><span class="text-xs text-600 white-space-nowrap">{{'SUBSCRIPTIONS.SERVICES.RECURRING'| translate }}</span></th>
        <th class="surface-100 border-0 py-2"><span class="text-xs text-600 white-space-nowrap">{{'SUBSCRIPTIONS.SERVICES.AVAILABLE_SESSION'| translate }}</span></th>
        <th class="surface-100 border-0 py-2"><span class="text-xs text-600 white-space-nowrap">{{'SUBSCRIPTIONS.SERVICES.SESSION_OWNER'| translate }}</span></th>
        <th class="surface-100 border-0 py-2"><span class="text-xs text-600 white-space-nowrap" *ngIf="subscriptionCategory === PlanCategory[PlanCategory.PaidInFull] || subscriptionCategory === PlanCategory.PaidInFull ">{{'SUBSCRIPTIONS.SERVICES.START_DATE'| translate }}</span></th>
        <th class="surface-100 border-0 py-2"><span class="text-xs text-600 white-space-nowrap" *ngIf="subscriptionCategory === PlanCategory[PlanCategory.PaidInFull] || subscriptionCategory === PlanCategory.PaidInFull">{{'SUBSCRIPTIONS.SERVICES.EXPIRY_DATE'| translate }}</span></th>
      </tr>
    </ng-template>
    <ng-template pTemplate="loadingbody" let-columns>
      <tr>
        <td>
          <p-skeleton width="85%" height="2rem"></p-skeleton>
        </td>
        <td>
          <p-skeleton width="60%" height="2rem"></p-skeleton>
        </td>
        <td>
          <p-skeleton width="70%" height="2rem"></p-skeleton>
        </td>
        <td>
          <p-skeleton width="80%" height="2rem"></p-skeleton>
        </td>
        <td *ngIf="subscriptionCategory === PlanCategory[PlanCategory.PaidInFull] || subscriptionCategory === PlanCategory.PaidInFull">
          <p-skeleton width="65%" height="2rem"></p-skeleton>
        </td>
        <td *ngIf="subscriptionCategory === PlanCategory[PlanCategory.PaidInFull] || subscriptionCategory === PlanCategory.PaidInFull">
          <p-skeleton width="65%" height="2rem"></p-skeleton>
        </td>
      </tr>
      <tr>
        <td>
          <p-skeleton width="75%" height="2rem"></p-skeleton>
        </td>
        <td>
          <p-skeleton width="50%" height="2rem"></p-skeleton>
        </td>
        <td>
          <p-skeleton width="65%" height="2rem"></p-skeleton>
        </td>
        <td>
          <p-skeleton width="85%" height="2rem"></p-skeleton>
        </td>
        <td *ngIf="subscriptionCategory === PlanCategory[PlanCategory.PaidInFull] || subscriptionCategory === PlanCategory.PaidInFull">
          <p-skeleton width="65%" height="2rem"></p-skeleton>
        </td>
        <td *ngIf="subscriptionCategory === PlanCategory[PlanCategory.PaidInFull] || subscriptionCategory === PlanCategory.PaidInFull">
          <p-skeleton width="65%" height="2rem"></p-skeleton>
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td [attr.colspan]="(subscriptionCategory === PlanCategory[PlanCategory.PaidInFull] || subscriptionCategory === PlanCategory.PaidInFull) ? 6 : 4" class="text-center p-4">
          <div class="text-600">{{'SUBSCRIPTIONS.NO_SERVICES' | translate}}</div>
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-service>
      <tr class="text-sm">
        <td class="py-2 white-space-nowrap">
        <strong>{{service.service_category_name_primary_language ||  service.service_category_name_secondary_language }}</strong>
        <span *ngIf="service.service_is_base_membership" class="inline-block px-2 line-height-4 text-xxs surface-200 border-round font-normal text-600 ml-2">
          {{'SUBSCRIPTIONS.BASE-MEMEBERSHIP'| translate }}
        </span>
        </td>
        <td class="py-2 white-space-nowrap">
          <span *ngIf="service.is_recurring"><i class="fa fa-refresh mr-2"></i>{{'common.BUTTONS.BUTTON-TEXT-YES'| translate }}</span>
          <span *ngIf="!service.is_recurring"><i class="fa fa-ban mr-2"></i>{{'common.BUTTONS.BUTTON-TEXT-NO'| translate }}</span>
        </td>
        <td class="py-2 white-space-nowrap">
          <div class="flex align-items-center" >
            <span *ngIf="service.service_sessions === 0; else sessionAvailable">-</span>
            <ng-template #sessionAvailable>
              <span><strong>{{service.available_sessions}}</strong> of {{service.service_sessions}}</span>
              <p-button *ngIf="isNonRecurringPlan()" (click)="ChangeMembershipSessions(service)" [label]="'common.BUTTONS.BUTTON_TEXT_EDIT'| translate" icon="fa fa-pencil" styleClass="text-xs text-600 surface-0 p-button-outlined p-button-secondary border-400 py-1 px-2 ml-2"></p-button>
            </ng-template>
          </div>
        </td>
        <td class="py-2 white-space-nowrap">
          <div *ngIf="service.service_session_owner_id === 0; else ownerAvailable">
            <p-button [ngClass]="IsSubscrptionVoidOrCancelled() ?'opacity-40 pointer-events-none' :'' " (click)="assignSessionOwner(service)" icon="fa fa-user-edit" [label]="'SUBSCRIPTIONS.ASSIGN_SESSION_OWNER' | translate" 
            styleClass="p-button-text text-primary font-bold text-sm py-1 px-2 ml-3"></p-button>
          </div>
          <!-- <div *ngIf="service.service_session_owner_id == 0 && service.service_behaviour !='AppointmentPackage'">-
          </div> -->
          <ng-template #ownerAvailable>
            <ng-container  *ngIf="GetStaff(service.service_session_owner_id) | async as sessionOwner">
              <div class="flex align-items-center">
                <div class="cursor-pointer flex align-items-center" (mouseenter)="assignedTo.show($event)" (mouseleave)="assignedTo.hide()">
                    <div>
                        <p-avatar *ngIf="sessionOwner.ff_picture !== null && sessionOwner.ff_picture !== ''; else showName" [image]="sessionOwner.ff_picture">
                       </p-avatar>
                       <ng-template #showName>
                        <p-avatar  styleClass="text-sm mr-3" [label]="sessionOwner.name | titlecase | shortName">
                        </p-avatar>
                       </ng-template>
                       
                    </div>
                    <span  class="text-primary white-space-nowrap ml-2">{{sessionOwner.name}}</span>
                </div>
                <p-button [ngClass]="IsSubscrptionVoidOrCancelled() ?'opacity-40 pointer-events-none' :'' " (click)="assignSessionOwner(service)" icon="fa fa-pencil" [label]="'common.BUTTONS.BUTTON_TEXT_EDIT' | translate" styleClass="p-button-outlined text-700 border-400 text-sm py-1 px-2 ml-3"></p-button>
              </div>
              <p-popover #assignedTo styleClass="overflow-hidden text-sm w-23rem">
                <ng-template #content>
      
                  <!-- Dropdown Content -->
                  <div class="surface-0 -mx-4 -mt-4 flex align-items-center justify-content-between p-3">
                    <div class="flex align-items-center">
                      <span class="text-base font-medium text-800">{{sessionOwner.name}}</span>
                      <span class="text-xs text-600 ml-3">{{sessionOwner.id}}</span>
                    </div>
                    <span
                      class="bg-blue-50 px-2 py-1 font-bold border-round border-1 border-primary text-primary text-xxs">{{sessionOwner.role}}</span>
                  </div>
                  <!-- Dropdown Content -->
      
                  <!-- Dropdown Footer -->
                  <div class="p-3 -mx-4 -mb-4 flex align-items-center justify-content-between surface-200 text-800">
                    <div class="flex align-items-center mr-4 w-6">
                      <i class="fa fa-phone mr-2 text-500"></i>
                      <span></span>
                      <div *ngIf="sessionOwner.mobile_number; else phoneMissing"> {{sessionOwner.mobile_country_code + " " + sessionOwner.mobile_number || ""}}</div>
                      <ng-template #phoneMissing>
                        <i class="text-600">N/A</i>
                      </ng-template>
                    </div>
                    <div class="flex align-items-center justify-content-end w-6">
                      <i class=" fa fa-envelope font-light mr-2 text-500"></i>
                      <div *ngIf="sessionOwner.email_id; else emailMissing">{{sessionOwner.email_id}}</div>
                      <ng-template #emailMissing>
                        <i class="text-600">N/A</i>
                      </ng-template>
                    </div>
                  </div>
                  <!-- Dropdown Footer -->
                </ng-template>
              </p-popover>
            </ng-container>
        </ng-template>

        </td>
        <td class="py-2 white-space-nowrap" *ngIf="subscriptionCategory === PlanCategory[PlanCategory.PaidInFull] || subscriptionCategory === PlanCategory.PaidInFull">
            <div class="flex align-items-center" >
            <span>{{service.service_start_date  | date : 'MMM d, yy'}}</span>
            <p-button [ngClass]="CanEditDates() || restrictToDateChange ?'opacity-40 pointer-events-none' :'' " (click)="ChangeDate(service)" [label]="'common.BUTTONS.BUTTON_TEXT_EDIT'| translate" icon="fa fa-pencil" styleClass="text-xs text-600 surface-0 p-button-outlined p-button-secondary border-400 py-1 px-2 ml-2"></p-button>
            </div>
        </td>
        <td class="py-2 white-space-nowrap" *ngIf="subscriptionCategory === PlanCategory[PlanCategory.PaidInFull] || subscriptionCategory === PlanCategory.PaidInFull">
          {{ service.service_end_date | date : 'MMM d, yy' }}
        </td>
      </tr>
    </ng-template>
</p-table>

  <!-- Assign Session Owner Modal  -->
<p-dialog *ngIf="assignSessionOwnerModal | async" [(visible)]="assignSessionOwnerModal" (onHide)="assignSessionOwnerModal.next(false)" [resizable]="false"
appendTo="body" [modal]="true" [breakpoints]="{'767px': '100vw'}" [style]="{width: '470px'}"
styleClass="no-header-modal overflow-visible">

<ng-template pTemplate="header" styleClass="hidden"></ng-template>
<ng-template pTemplate="content" styleClass="p-0">
  <!-- Header -->
  <div class="surface-0 p-3 md:px-4 flex align-items-center justify-content-between">
    <h2 class="mb-0 text-base md:text-lg line-height-1">{{'SUBSCRIPTIONS.ASSIGN_SESSION_OWNER' | translate}}</h2>
    <div class="fa fa-times text-xl text-600 cursor-pointer" (click)="assignSessionOwnerModal.next(false)"></div>
  </div>
  <!-- Header -->

  <!-- Modal Content -->
    <div>
      <h6 class="text-sm bg-blue-50 mb-0 p-3">{{ selectedService.service_category_name_primary_language || selectedService.service_category_name_secondary_language }}
      </h6>
      <div class="p-3">
        <label class="font-medium text-700 text-xs mb-2 uppercase">{{'SUBSCRIPTIONS.SESSION_OWNER' | translate}}</label>
        <staff-selector [formGroup]="changeSessionOwnerForm" [id]="getSessionOwnerId(selectedService.service_session_owner_id)"
          [controlName]="getSessionOwnerFC('SelectedAssignedFormControl_' + selectedService.service_id)"
          [styleClass]="'border-none surface-50 w-full'" [placeHolder]="'common.PLACEHOLDER.SELECT' | translate"
          [filterstaff]="sessionOwner" (selectedStaff)="getSelectedStaff($event,selectedService)">
        </staff-selector>
      </div>
    </div>
  <!-- Modal Content -->

</ng-template>
</p-dialog>
<!-- Assign Session Owner Modal -->


<subscription-start-end-date-edit *ngIf="showEditStartEndDate" [visible]="showEditStartEndDate" [clientId]="clientId" [tenantId]="tenantId"
 [subscription]="subscription" [membershipId]="membershipId" (closeEvent)="closeDateChangeEvent($event)">
</subscription-start-end-date-edit>

<membership-sessions-edit *ngIf="showEditMembershipSessions" [visible]="showEditMembershipSessions" [clientId]="clientId" [tenantId]="tenantId"
 [subscription]="subscription" [membershipId]="membershipId" (closeEvent)="closeMembershipSessionsEvent($event)">
</membership-sessions-edit>

